import getAdminInitialState from './admin_details/states';

import filter_states from './filter_details/states';
import chats_states from './chats_details/states';
import history_states from './history_details/states';
import nlp_states from './nlp_details/states';
import dashboard_states from './dashboard_details/states';
import usage_states from './usage_details/states';
import chatlog_states from './chatlog_details/states';
import session_flow_states from './session_flow_details/states';
import conversion_states from './conversion_details/states';
import feedback_states from './feedback_details/states';
import botbuilder_states from './botbuilder_details/states';
import botmessage_states from './botmessage_details/states';
import intent_states from './intent_details/states';
import entity_states from './entity_details/states';
import team_member_setting_states from './team_member_setting_details/states';
import event_states from './event_details/states';
import users_states from './users_details/states';
import botparams_details from './botparams_details/states';
import member_details from './member_details/states';
import agent_monitoring_details from './agent_monitoring_details/states';
import kpi_states from './kpi_details/states'
import downtime_states from './downtime_details/states'
import brand_function_states from './brand_function_details/states'
import query_states from './query_details/states';
import model_accuracy_states from './model_accuracy_details/states'
import apilogs_states from './apilogs_details/states'
import reports_details from './reports_details/states'
import fracture_states from './fracture_details/states'

const getInitialStates = () => {
  const admin_initial_states = getAdminInitialState()
  return {
    ...admin_initial_states,
    ...chats_states,
    ...filter_states,
    ...history_states,
    ...nlp_states,
    ...dashboard_states,
    ...usage_states,
    ...chatlog_states,
    ...session_flow_states,
    ...conversion_states,
    ...feedback_states,
    ...botbuilder_states,
    ...botmessage_states,
    ...intent_states,
    ...entity_states,
    ...team_member_setting_states,
    ...event_states,
    ...users_states,
    ...downtime_states,
    ...botparams_details,
    ...member_details,
    ...agent_monitoring_details,
    ...kpi_states,
    ...brand_function_states,
    ...query_states,
    ...model_accuracy_states,
    ...apilogs_states,
    ...reports_details,
    ...fracture_states
  }
}

export default getInitialStates;




// WEBPACK FOOTER //
// ./src/data/redux/initial_states.js